<div class="bg-white rounded mb-4 p-2 shadow-sm">
  <button
    class="ap-flex justify-content-between align-items-center w-100 pt-1 pb-1 bg-transparent"
    (click)="toggle()">
    <div accordion-header class="d-flex align-items-center">
      <div class="ap-pr-spacing-2">
        <ng-content select="[accordion-header]"> </ng-content>
      </div>
      @if (hasError) {
        <span
          class="bg-danger bg-error d-inline-block p-1 mb-1 rounded rounded-3"></span>
      }
    </div>
    <div>
      <span
        class="Appkit4-icon icon-down-chevron-outline ap-font-16 arrow"
        [class.is-expanded]="accordionItem().isExpanded"
        aria-hidden="true"></span>
      <ng-content select="[accordion-header-end]"></ng-content>
    </div>
  </button>
  <div
    class="ap-pr-spacing-5 ap-pl-spacing-5"
    [gstarExpandCollapse]="accordionItem()">
    <div>
      <ng-content />
    </div>
  </div>
</div>
